<template>
  <div class="table-responsive">
    <p>
      Segue abaixo a exibição do histórico de reajustes dos valores dos contratos.
    </p>
    <div class="container-table">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th nowrap class="text-center" width="50">Alterado por</th>
            <th nowrap class="text-center" width="50">Mês de aniversário</th>
            <th nowrap class="text-center" width="50">Porcentagem</th>
            <th nowrap class="text-center" width="50">Contratos</th>
            <th nowrap class="text-center" width="10">Data</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(audit, index) in paginatedData">
            <tr
              data-toggle="collapse"
              :data-target="'#fields' + index"
              class="clickable pointer"
              :key="index"
            >
              <td class="text-center">{{ audit.name }}</td>
              <td class="text-center">
                {{ getFieldModifiedValue(audit.birthday_month) }}
              </td>
              <td class="text-center">
                {{ audit.percent }}
              </td>
              <td class="text-center">
                {{ audit.contract_id }}
              </td>
              <td class="text-center">{{ audit.event_date | date }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <nav v-if="totalPages > 1" aria-label="History pagination">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
            Anterior
          </a>
        </li>
        <li 
          v-for="page in visiblePages" 
          :key="page" 
          class="page-item" 
          :class="{ active: page === currentPage }"
        >
          <a class="page-link" href="#" @click.prevent="changePage(page)">
            {{ page }}
          </a>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
            Próximo
          </a>
        </li>
      </ul>
    </nav>

    <div class="text-center mt-2" v-if="data.length > 0">
      <small class="text-muted">
        Mostrando {{ ((currentPage - 1) * itemsPerPage) + 1 }} a 
        {{ Math.min(currentPage * itemsPerPage, data.length) }} 
        de {{ data.length }} registros
      </small>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'CustomerContractHistory',
  data() {
    return {
      data: [],
      page: 1,
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  methods: {
    getFieldModifiedValue(month) {
      let stringMonth = month;

      switch (stringMonth) {
        case '0':
          stringMonth = 'Todos';
          break;
        case '1':
          stringMonth = 'Janeiro';
          break;
        case '2':
          stringMonth = 'Fevereiro';
          break;
        case '3':
          stringMonth = 'Março';
          break;
        case '4':
          stringMonth = 'Abril';
          break;
        case '5':
          stringMonth = 'Maio';
          break;
        case '6':
          stringMonth = 'Junho';
          break;
        case '7':
          stringMonth = 'Julho';
          break;
        case '8':
          stringMonth = 'Agosto';
          break;
        case '9':
          stringMonth = 'Setembro';
          break;
        case '10':
          stringMonth = 'Outubro';
          break;
        case '11':
          stringMonth = 'Novembro';
          break;
        case '12':
          stringMonth = 'Dezembro';
          break;
        default:
      }

      return stringMonth;
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/contract-readjustment`;
      axios(url).then((res) => {
        this.data = res.data;
        this.currentPage = 1;
      });
    },
  },
  beforeMount() {
    this.getDatas();
  },
  computed: {
    customerId() {
      return this.$store.state.showCustomerSave;
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.data.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      
      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }
      
      return pages.filter(page => page !== '...' || pages.indexOf(page) === pages.lastIndexOf(page));
    },
  },
};
</script>

<style scoped>
.pagination .page-link {
  border-radius: 0.25rem;
  margin: 0 2px;
}
</style>
